import React from 'react';
import { MULTIPLES_OPTIONS } from 'dashboard409a/common/constants/components/metrics';
import { RatesOfChange } from 'dashboard409a/components';
import { IValueOverTimeProps } from './types';

const ValueOverTime = ({ chartData, isLoading }: IValueOverTimeProps) => (
  <RatesOfChange chartData={chartData} isLoading={isLoading} metricOptions={MULTIPLES_OPTIONS} />
);

export default ValueOverTime;
